// @flow

export const productionTypes = Object.freeze({
  Dish: 'dish',
  Complex: 'complex',
});

export type ProductionTypes = $Values<typeof productionTypes>
